import styled from "styled-components";

const StyledCard = styled.div`
 
  position: relative;
  display: flex;
  flex-direction: column;
  border-style: solid;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.2);
  border-radius: 0.5rem;
  background-color: #fff;

  .card_body {
    display: flex;
    padding: 2rem 1rem;
    flex-direction: column;
    flex: 1 1 auto;
  }
  
  .card_title {
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-size: calc(1.5rem + .1vw);
    line-height: 1.1;
  }

  .card-subtitle {
    margin-top: 0;
    margin-bottom: 0.25rem;
    font-size: calc(1.2rem + .1vw);
    line-height: 1.1;
  }

`

export default StyledCard;